import {
  Component,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  ViewChild,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { Subject } from 'rxjs';
import { Category } from 'src/app/models/shopping/category';
import { EventEmitter } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-category-tree',
  templateUrl: './category-tree.component.html',
  styleUrls: ['./category-tree.component.scss']
})
export class CategoryTreeComponent implements OnInit, OnChanges, OnDestroy {

  @Output() onCategorySelected = new EventEmitter<{ category: Category, checked: boolean }>();

  @Input() category: Category;
  @Input() showCheckbox: boolean = true;
  @Input() doSelectChildren: Subject<void>;
  @Input() doClearAll: Subject<void>;
  @Input() categoriesSelected: number[] = [];
  @Input() doClearChildren: Subject<void>;

  @Input() expandedCategoryIds: Set<number>;

  @ViewChild('checkbox') checkbox: any;

  public checked: boolean = false;
  public collapsed: boolean = true;

  private destroy$ = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.doClearChildren?.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.checked = false;
    });

    this.doClearAll?.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.checked = false;
      this.onCategorySelected.emit({ category: this.category, checked: false });
    });

    this.doSelectChildren?.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.checked = true;
      this.onCategorySelected.emit({ category: this.category, checked: true });
      this.collapsed = false;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.categoriesSelected?.currentValue) {
      this.checked = this.categoriesSelected.includes(this.category.catId);
    }

    if (changes.expandedCategoryIds?.currentValue) {
      // Expand if this category id is in expandedCategoryIds
      this.collapsed = !this.expandedCategoryIds.has(this.category.catId);
      this.cdr.detectChanges();
    }

    if (changes.category?.currentValue && this.category?.children?.length) {
      this.category.children.sort((a, b) => a.catName.localeCompare(b.catName));
    }
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCheckboxClicked(e: any, cat: Category): void {
    this.checked = e.checked;

    // Emit selected or deselected
    this.onCategorySelected.emit({ category: cat, checked: e.checked });

    // Recursively apply checked status to children
    if (cat.children?.length > 0) {
      cat.children.forEach(child => {
        const childCheckbox = document.getElementById('category_checkbox_' + child.catId) as HTMLInputElement;
        if (childCheckbox) {
          childCheckbox.checked = e.checked;
        }
        this.onCategorySelected.emit({ category: child, checked: e.checked });
      });
    }

    // Expand the category if checked
    if (e.checked) {
      this.collapsed = false;
    }
  }



}
